module.exports = __webpack_public_path__ + "img/Group (16).5eda0cee.svg";